import './iframe.scss';
import { uniqueID } from './../../utilities/js/helper';
import iframeResize from '@iframe-resizer/parent';

class Iframe {
    constructor ($element, options) {
        const defaults = {
            licenceKey: '1jy4dww5qzv-s54r73oxcn-v59f4kfgfz'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$iframe = $element;

        this.initialize();
    }

    initialize () {
        const iframeId = 'iframe_' + uniqueID();
        this.$iframe.setAttribute('id', iframeId);

        iframeResize({
            license: this.settings.licenceKey
        }, '#' + iframeId);
    }
}

export { Iframe };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$iframe = $context.querySelectorAll('[data-iframe="root"]');
        for (let i = 0; i < $$iframe.length; i++) {
            const $iframe = $$iframe[i];

            $iframe.API = new Iframe($iframe);
        }
    }
});
